
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...all]]",
      function () {
        return require("private-next-pages/[[...all]].jsx");
      }
    ]);
  